export var IS_SEARCH_ENGINE = 'IS_SEARCH_ENGINE';
export var SET_SEARCH_ENGINE_STATUS = 'SET_SEARCH_ENGINE_STATUS';
export var IS_SEARCH_ENGINE_ACTION = 'IS_SEARCH_ENGINE_ACTION';